import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import type { CustomRouteComponentProps } from 'react-router-dom';
import { compose } from 'redux';
import type { InjectedFormProps } from 'redux-form';
import { reduxForm, formValueSelector } from 'redux-form';

import type { EquipmentRequestModel } from 'ab-requestModels/equipment.requestModel';

import type { RootState } from 'af-reducers';

import { EQUIPMENT_CREATE } from 'af-constants/reduxForms';
import CLIENT from 'af-constants/routes/client';

import Breadcrumbs from 'af-components/Breadcrumbs';
import CreateEquipmentForm from 'af-components/SharedForms/Resources/Equipment';
import { validate } from 'af-components/SharedForms/Resources/Equipment/validation';

import * as EquipmentActions from 'af-actions/equipment';

type OwnProps = CustomRouteComponentProps;

type Props = OwnProps & ConnectedProps<typeof connector> & InjectedFormProps<EquipmentRequestModel>;

class Create extends React.Component<Props> {

	createEquipment = async (form: EquipmentRequestModel) => {
		const { history, create, location: { state: { orgAlias } }, companyName } = this.props;
		await create(form);
		history.push(CLIENT.COMPANY.EQUIPMENT.TABLE(orgAlias, companyName));
	};

	render() {
		const {
			location: { state: { orgAlias } },
			companyName,
		} = this.props;

		return (
			<div className="form-segment">
				<Breadcrumbs
					items={[
						{ label: 'Equipment', url: `${CLIENT.COMPANY.EQUIPMENT.TABLE(orgAlias, companyName)}` },
						{ label: 'New Equipment' },
					]}
				/>
				<CreateEquipmentForm
					{...this.props}
					onSubmit={this.createEquipment}
				/>
			</div>
		);
	}
}

const formSelector = formValueSelector(EQUIPMENT_CREATE);

interface FormActionWrapper {
	selector: <T extends keyof EquipmentRequestModel>(fieldName: T) => EquipmentRequestModel[T];
}
const formActionWrapper: Partial<FormActionWrapper> = {
	selector: undefined,
};

function mapStateToProps(state: RootState) {
	const { companyData } = state.user;
	if (!companyData) {
		throw new Error('User not logged in');
	}

	formActionWrapper.selector = (fieldName: keyof EquipmentRequestModel) => formSelector(state, fieldName);

	return {
		formActionWrapper: formActionWrapper as FormActionWrapper, // selector is no longer undefined
		companyName: companyData.name,
	};
}

function mapDispatchToProps() {
	return {
		create: EquipmentActions.create,
	};
}

const connector = connect(mapStateToProps, mapDispatchToProps());

const enhance = compose<React.ComponentClass<OwnProps>>(
	connector,
	reduxForm({
		form: EQUIPMENT_CREATE,
		validate,
		enableReinitialize: true,
		initialValues: {
			showOnScheduleBoard: true,
			equipmentStatusId: -1,
		},
	})
);

export default enhance(Create);
